/**
 * GENERATED_ASSET — recipe constants for the adopted static Hush kit (no JSON import, so any bundler works).
 * Canonical source: batch001 kit `recipes/assets.json` (copied exactly from the Hush catalog's asset-recipes).
 */
import type { LanternRecipe, PaperBoatRecipe, ReedCurtainRecipe, RibbonRecipe } from './contracts';

/** Canonical `hush.lantern.salt_worn.v1`, unchanged (support: 'hanging'). */
export const HUSH_LANTERN_SALT_WORN: LanternRecipe = {
  schema: 'hush.asset-recipe.v1',
  id: 'hush.lantern.salt_worn.v1',
  assetId: 'prop.hush.three_window_lantern',
  generatorId: 'hush.lantern.v1',
  seed: 20067018,
  paletteId: 'coastal_salt',
  detail: 'standard',
  params: { condition: 'salt_worn', support: 'hanging', paperWear: 0.35, warmth: 0.65, repairNotch: 'lower-left' },
};

/**
 * DERIVED standing instance for the `three_window_lantern` game template.
 *
 * Every live placement of that template stands on the floor, so the game uses the kit's STANDING support (wooden
 * foot + contact shadow, no hook, no `hang` anchor). It is `hush.lantern.salt_worn.v1` with exactly two edits:
 *   - params.support: 'hanging' -> 'standing'
 *   - id: suffixed '.standing'
 * `assetId` is NOT suffixed: the kit validator pins it to 'prop.hush.three_window_lantern', and it is part of every
 * seeded channel (`${seed}|${assetId}|${channel}`), so renaming it would silently change the outline and paper grain.
 * The canonical hanging recipe itself backs `three_window_lantern_hanging` (hung from `lantern_brace`).
 */
export const HUSH_LANTERN_SALT_WORN_STANDING: LanternRecipe = {
  ...HUSH_LANTERN_SALT_WORN,
  id: `${HUSH_LANTERN_SALT_WORN.id}.standing`,
  params: { ...HUSH_LANTERN_SALT_WORN.params, support: 'standing' },
};

/** Canonical `hush.ribbon.rest.v1`, unchanged (tie anchor at the knot, tails hang down). */
export const HUSH_RIBBON_REST: RibbonRecipe = {
  schema: 'hush.asset-recipe.v1',
  id: 'hush.ribbon.rest.v1',
  assetId: 'prop.hush.crooked_ribbon',
  generatorId: 'hush.ribbon.v1',
  seed: 20067018,
  paletteId: 'coastal_salt',
  detail: 'standard',
  params: { pose: 'rest', tailLength: 62, shortTailRatio: 0.65, width: 12, fray: 1, seam: 'short-repair' },
};

/** Canonical `hush.reeds.concealed.v1` (28-unit protected gap). */
export const HUSH_REEDS_CONCEALED: ReedCurtainRecipe = {
  schema: 'hush.asset-recipe.v1',
  id: 'hush.reeds.concealed.v1',
  assetId: 'prop.hush.reed_curtain',
  generatorId: 'hush.reeds.v1',
  seed: 20067018,
  paletteId: 'coastal_salt',
  detail: 'standard',
  params: { opening: 'concealed', width: 170, height: 150, stalksPerSide: 8, gapWidth: 28, tieHeightRatio: 0.48, tipSpread: 17 },
};

/** Canonical `hush.reeds.return_open.v1` (68-unit protected gap, gathered open). */
export const HUSH_REEDS_RETURN_OPEN: ReedCurtainRecipe = {
  schema: 'hush.asset-recipe.v1',
  id: 'hush.reeds.return_open.v1',
  assetId: 'prop.hush.reed_curtain',
  generatorId: 'hush.reeds.v1',
  seed: 20067018,
  paletteId: 'nook_warm',
  detail: 'standard',
  params: { opening: 'gathered_open', width: 190, height: 150, stalksPerSide: 8, gapWidth: 68, tieHeightRatio: 0.48, tipSpread: 17 },
};

/**
 * Pip's held clue boat: batch-003 wardrobe `recipes/static-resources.json` `hush.boat.pip_clue.v1`, unchanged.
 * Consumed by the Hush wardrobe (Pip's held prop) only; the `paper_boat` map template keeps its own art.
 */
export const HUSH_BOAT_PIP_CLUE: PaperBoatRecipe = {
  schema: 'hush.asset-recipe.v1',
  id: 'hush.boat.pip_clue.v1',
  assetId: 'prop.hush.paper_boat',
  generatorId: 'hush.paper_boat.v1',
  seed: 20067018,
  paletteId: 'coastal_salt',
  detail: 'standard',
  params: { fold: 'classic', condition: 'clean', clueTab: 'two_over_one', leanDeg: 0, paperWear: 0.1 },
};
